import { Divider, Tooltip } from 'antd';
import React from 'react';
import { ReactComponent as InfoIcon } from '../../../../../assets/svg/info-solid.svg';
import {
  COUPON_LOGIC_EFFECTIVE_DATE,
  COUPON_TYPE,
  DATE_FORMATS,
  DEVICE_TYPE,
  PAYMENT_PROVIDERS_TYPE,
  PLAN_NAMES,
  PLAN_TYPES,
  SUBSCRIPTION_UPDATED_BY,
  TRANSACTION_HISTORY_TYPES,
} from '../../../../../common/constants';
import { billableAmount, formatDate } from '../../../../../common/utils';
import ModalComponent from '../../../../../components/ModalComponent';

const InvoiceModal = ({ isModalOpen, setIsModalOpen, inflow }) => {
  const {
    subscription = {},
    transactionNumber,
    user,
    type,
    createdAt,
    price: inflowPrice,
    metaData: inflowMetaData = {},
  } = inflow || {};
  const {
    metaData = {},
    subscriptionPlan = {},
    subscriptionFeatures = {},
    coupon,
    subscriptionId,
    couponDetails = {},
  } = subscription || {};
  const { taxesApplied } = inflowMetaData || {};
  const { isCouponAppliedOnSubscriptionRenew } = couponDetails || {};
  const {
    membershipData = {},
    isSecurityDeposit,
    paymentProvider,
    userTrialApplied: isTrialPeriod,
    userDamageWaiverFeesApplied: isDamageWaiver,
    deviceType,
    updatedBy,
    gstApplied,
    gstPercentage,
    priceBreakdown,
  } = metaData || {};
  const hasPriceBreakdown = !!(
    priceBreakdown &&
    (priceBreakdown.finalPrice !== undefined && priceBreakdown.finalPrice !== null)
  );
  const { price, type: planType, name } = subscriptionPlan || {};
  const {
    planVersion,
    memberShipFees,
    trialDays,
    membershipFeesApplied,
    actualChargesForSecurityDeposit,
    actualChargesForMemberShipFees,
    securityDepositApplied,
    refundableDeposit,
    trialApplied,
    trialAmount,
    actualChargesForDamageWaiverFees,
    damageWaiverFees,
    damageWaiverFeesApplied,
    Discount,
  } = subscriptionFeatures || {};
  const version = parseInt(planVersion?.split('v')?.[1] || 0, 10);
  const finalDamageWaiverFees = isTrialPeriod
    ? 0
    : actualChargesForDamageWaiverFees;

  const isMembershipFee = membershipData?.isMembershipFee
    ? membershipData?.amount
    : 0;
  const appliedMembershipFees =
    membershipData?.isMembershipFee === true ||
    membershipData?.isMembershipFee === false
      ? isMembershipFee
      : memberShipFees;
  const planVersion2 = version >= process.env.REACT_APP_PLAN_VERSION;

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const isNewLogic =
    !createdAt || new Date(createdAt) >= new Date(COUPON_LOGIC_EFFECTIVE_DATE);

  let finalPlanCharges;
  if (isTrialPeriod) {
    if (
      trialApplied &&
      (!securityDepositApplied ||
        parseInt(actualChargesForSecurityDeposit, 10) <= 0)
    ) {
      finalPlanCharges = trialAmount;
    } else {
      finalPlanCharges = actualChargesForSecurityDeposit;
    }
  } else {
    finalPlanCharges = price;
  }

  let couponDiscount = 0;
  if (coupon) {
    if (COUPON_TYPE?.FLAT?.value === coupon?.type) {
      couponDiscount = coupon?.value;
    } else {
      const discountPercentage = coupon?.value / 100;
      if (isNewLogic) {
        couponDiscount = Math.round(finalPlanCharges * discountPercentage);
      } else {
        couponDiscount = Math.round(price * discountPercentage);
      }
    }
  }

  // const isSameRefundableDeposits =
  //   refundableDeposit !== actualChargesForSecurityDeposit;

  let trialAmountValue = 0;
  if (trialApplied && isTrialPeriod) {
    if (securityDepositApplied) {
      if (parseInt(actualChargesForSecurityDeposit, 10) <= 0) {
        trialAmountValue = trialAmount;
      } else {
        trialAmountValue = actualChargesForSecurityDeposit;
      }
    } else {
      trialAmountValue = trialAmount;
    }
  } else {
    trialAmountValue = 0;
  }

  let isMembershipFeesApplied;
  if (membershipFeesApplied) {
    if (planVersion2) {
      isMembershipFeesApplied = parseInt(actualChargesForMemberShipFees, 10);
    } else {
      isMembershipFeesApplied = parseInt(memberShipFees, 10);
    }
  } else {
    isMembershipFeesApplied = 0;
  }
  const isSecurityDepositsApplied = membershipFeesApplied
    ? parseInt(actualChargesForSecurityDeposit, 10)
    : 0;

  const isCouponOnRenew = isCouponAppliedOnSubscriptionRenew && couponDetails;
  const totalCouponDiscount = isCouponOnRenew ? 0 : couponDiscount;

  let couponDiscountForSubtotal = totalCouponDiscount;
  if (isNewLogic) {
    if (coupon?.type === COUPON_TYPE?.FLAT?.value) {
      couponDiscountForSubtotal = 0;
    }
  }

  const totalAmount =
    isTrialPeriod === true || isTrialPeriod === false || planVersion2
      ? parseInt(
          isTrialPeriod
            ? trialAmountValue + isMembershipFeesApplied
            : price + isSecurityDepositsApplied + isMembershipFeesApplied,
          10,
        ) -
          couponDiscountForSubtotal +
          (isDamageWaiver ? finalDamageWaiverFees : 0) || 0
      : billableAmount(
          price,
          appliedMembershipFees - couponDiscountForSubtotal,
          isSecurityDeposit !== false ? refundableDeposit : 0,
        );

  const gst = inflow?.metaData?.taxesApplied?.percentage
    ? inflowPrice * (inflow?.metaData?.taxesApplied?.percentage / 100)
    : 0;

  let couponDiscountForGST = couponDiscount;
  if (isNewLogic) {
    if (coupon?.type === COUPON_TYPE?.FLAT?.value) {
      couponDiscountForGST = 0;
    } else {
      couponDiscountForGST = isCouponOnRenew ? 0 : couponDiscount;
    }
  }
  let gstDeduction = 0;
  if (gstApplied && gstPercentage > 0) {
    if (isTrialPeriod) {
      gstDeduction = Math.ceil(
        (trialAmountValue -
          couponDiscountForGST +
          (membershipFeesApplied
            ? parseInt(actualChargesForMemberShipFees, 10)
            : 0)) *
          (gstPercentage / 100),
      );
    } else {
      gstDeduction = Math.ceil(
        (price -
          couponDiscountForGST +
          (membershipFeesApplied
            ? parseInt(actualChargesForMemberShipFees, 10)
            : 0) +
          (isDamageWaiver ? finalDamageWaiverFees : 0)) *
          (gstPercentage / 100),
      );
    }
  }

  let grandTotalCouponDiscount = 0;
  if (isNewLogic) {
    if (coupon?.type === COUPON_TYPE?.FLAT?.value) {
      grandTotalCouponDiscount = isCouponOnRenew ? 0 : couponDiscount;
    }
  }

  const grandTotal =
    totalAmount +
    gstDeduction -
    ((Discount || 0) * totalAmount) / 100 -
    grandTotalCouponDiscount;

  return (
    <>
      <ModalComponent
        open={isModalOpen}
        onCancel={handleCancel}
        title={
          type !== TRANSACTION_HISTORY_TYPES.DELIVERY_CHARGED.value
            ? 'Invoice of Subscription Plan'
            : 'Invoice of Delivery Charge'
        }
        footer={null}
      >
        <Divider />
        <div className="d-flex justify-between">
          <div className="lib-modal-text">Invoice Number</div>
          <div className="lib-modal-text-value">{transactionNumber || '-'}</div>
        </div>
        <div className="d-flex justify-between">
          <div className="lib-modal-text">User Name</div>
          <div className="lib-modal-text-value">
            {user?.firstName || user?.lastName
              ? `${user?.firstName || ''} ${user?.lastName || ''}`
              : '-'}
          </div>
        </div>
        <div className="d-flex justify-between">
          <div className="lib-modal-text">Generated On</div>
          <div className="lib-modal-text-value">
            {formatDate(createdAt, DATE_FORMATS.REGULAR)}
          </div>
        </div>
        <div className="d-flex justify-between">
          <div className="lib-modal-text">Billing Cycle</div>
          <div className="lib-modal-text-value">
            {PLAN_TYPES?.[planType]?.key || '-'}
          </div>
        </div>
        <div className="d-flex justify-between">
          <div className="lib-modal-text">Plan Subscribed</div>
          <div className="lib-modal-text-value">
            {PLAN_NAMES?.[name]?.key || '-'}
          </div>
        </div>
        {(isTrialPeriod === true ||
          isTrialPeriod === false ||
          planVersion2) && (
          <div className="d-flex justify-between">
            <div className="lib-modal-text">Damage Waiver Applied</div>
            <div className="lib-modal-text-value">
              {isDamageWaiver ? 'Yes' : 'No'}
            </div>
          </div>
        )}
        <div className="d-flex justify-between">
          <div className="lib-modal-text">Payment Provider</div>
          <div className="lib-modal-text-value d-flex align-center">
            {PAYMENT_PROVIDERS_TYPE?.[paymentProvider]?.label || '-'}
            {paymentProvider && (
              <Tooltip
                title={
                  <>
                    <div>Subscription Id: {subscriptionId || '-'}</div>
                    <div>
                      Device Type:{' '}
                      {DEVICE_TYPE?.[deviceType]?.label || 'No Device Type'}
                    </div>
                  </>
                }
                placement="top"
                zIndex={1000}
                trigger="click"
              >
                <InfoIcon className="ml-8 pointer svg-icon" />
              </Tooltip>
            )}
          </div>
        </div>
        <div className="d-flex justify-between">
          <div className="lib-modal-text">Amount</div>
          <div className="lib-modal-text-value">
            {inflowPrice !== undefined &&
            inflowPrice !== null &&
            inflowPrice !== '' &&
            inflowPrice !== '-'
              ? `₹ ${inflowPrice}`
              : '-'}
          </div>
        </div>
        {[
          TRANSACTION_HISTORY_TYPES.DELIVERY_CHARGED.value,
          TRANSACTION_HISTORY_TYPES.REFUND_DELIVERY_CHARGED.value,
        ]?.includes(type) && (
          <>
            <div className="d-flex justify-between">
              <div className="lib-modal-text">
                GST{' '}
                {taxesApplied?.percentage && `(${taxesApplied?.percentage}%)`}
              </div>
              <div className="lib-modal-text-value">₹ {gst}</div>
            </div>
            <div className="d-flex justify-between">
              <h4>Total</h4>
              <h4>₹ {inflowPrice + gst}</h4>
            </div>
          </>
        )}
        {![
          TRANSACTION_HISTORY_TYPES.DELIVERY_CHARGED.value,
          TRANSACTION_HISTORY_TYPES.SUBSCRIPTION_RENEWED.value,
        ]?.includes(type) &&
          (updatedBy?.type !== SUBSCRIPTION_UPDATED_BY.ADMIN ||
            isSecurityDeposit !== false ||
            membershipData?.isMembershipFee !== false) && (
            <>
              <hr />
              <h4>Breakdown Details</h4>
              {hasPriceBreakdown ? (
                <>
                  <div className="d-flex justify-between">
                    <div className="lib-modal-text">
                      {isTrialPeriod ? `${trialDays} day trial` : 'Plan charges'}{' '}
                    </div>
                    <div className="lib-modal-text-value">
                      + ₹ {priceBreakdown.basePrice ?? 0}
                    </div>
                  </div>
                  {priceBreakdown.securityDeposit !== undefined &&
                    priceBreakdown.securityDeposit !== null &&
                    priceBreakdown.securityDeposit > 0 && (
                      <div className="d-flex justify-between">
                        <div className="lib-modal-text">Refundable Deposit</div>
                        <div className="lib-modal-text-value">
                          + ₹ {priceBreakdown.securityDeposit}
                        </div>
                      </div>
                    )}
                  {priceBreakdown.membershipFees !== undefined &&
                    priceBreakdown.membershipFees !== null &&
                    priceBreakdown.membershipFees > 0 && (
                      <div className="d-flex justify-between">
                        <div className="lib-modal-text">Membership Fees</div>
                        <div className="lib-modal-text-value">
                          + ₹ {priceBreakdown.membershipFees}
                        </div>
                      </div>
                    )}
                  {priceBreakdown.couponDiscount !== undefined &&
                    priceBreakdown.couponDiscount !== null &&
                    priceBreakdown.couponDiscount > 0 && (
                      <div className="d-flex justify-between">
                        <div className="lib-modal-text text-color-green">
                          Coupon Discount{' '}
                          {priceBreakdown.couponPercent && `(${priceBreakdown.couponPercent}%)`}{' '}
                          {priceBreakdown.couponCode && `(${priceBreakdown.couponCode})`}{' '}
                        </div>
                        <div className="lib-modal-text-value text-color-green">
                          - ₹ {priceBreakdown.couponDiscount}
                        </div>
                      </div>
                    )}
                  {priceBreakdown.damageWaiverFees !== undefined &&
                    priceBreakdown.damageWaiverFees !== null &&
                    priceBreakdown.damageWaiverFees > 0 && (
                      <div className="d-flex justify-between">
                        <div className="lib-modal-text">Damage Waiver Charges</div>
                        <div className="lib-modal-text-value">
                          + ₹ {priceBreakdown.damageWaiverFees}
                        </div>
                      </div>
                    )}
                  {priceBreakdown.gstAmount !== undefined &&
                    priceBreakdown.gstAmount !== null &&
                    priceBreakdown.gstAmount > 0 && (
                      <div className="d-flex justify-between">
                        <div className="lib-modal-text">GST Applied</div>
                        <div className="lib-modal-text-value">
                          + ₹ {priceBreakdown.gstAmount}
                        </div>
                      </div>
                    )}
                  {priceBreakdown.proRataCredit !== undefined &&
                    priceBreakdown.proRataCredit !== null &&
                    priceBreakdown.proRataCredit !== '' &&
                    priceBreakdown.proRataCredit !== '-' &&
                    !Number.isNaN(parseFloat(priceBreakdown.proRataCredit)) &&
                    parseFloat(priceBreakdown.proRataCredit) !== 0 && (
                      <div className="d-flex justify-between">
                        <div className="lib-modal-text" style={{ color: '#ec6c9b' }}>
                          Previous plan credit
                        </div>
                        <div className="lib-modal-text-value" style={{ color: '#ec6c9b' }}>
                          - ₹ {priceBreakdown.proRataCredit}
                        </div>
                      </div>
                    )}
                  {parseFloat(priceBreakdown.rentalCredit) > 0 && (
                    <div className="d-flex justify-between">
                      <div className="lib-modal-text text-color-green">
                        Rental Credit
                      </div>
                      <div className="lib-modal-text-value text-color-green">
                        - ₹ {priceBreakdown.rentalCredit}
                      </div>
                    </div>
                  )}
                  <div className="d-flex justify-between">
                    <h4>Total</h4>
                    <h4>₹ {priceBreakdown.finalPrice ?? 0}</h4>
                  </div>
                </>
              ) : (
                <>
                  <div className="d-flex justify-between">
                    <div className="lib-modal-text">
                      {isTrialPeriod ? `${trialDays} day trial` : 'Plan charges'}{' '}
                    </div>
                    {finalPlanCharges !== undefined &&
                    finalPlanCharges !== null ? (
                      <div className="lib-modal-text-value">
                        + ₹ {finalPlanCharges}
                      </div>
                    ) : (
                      '-'
                    )}
                  </div>
                  {isTrialPeriod ? (
                    <></>
                  ) : (
                    <>
                      {isSecurityDeposit !== false && (
                        <div className="d-flex justify-between">
                          <div className="lib-modal-text">
                            Refundable Deposit
                          </div>
                          {refundableDeposit ? (
                            <div className="lib-modal-text-value">
                              + ₹ {refundableDeposit}
                            </div>
                          ) : (
                            '-'
                          )}
                        </div>
                      )}
                      {membershipData?.isMembershipFee !== false && (
                        <div className="d-flex justify-between">
                          <div className="lib-modal-text">Membership Fees</div>
                          {memberShipFees && memberShipFees !== '-' ? (
                            <div className="lib-modal-text-value">
                              + ₹ {appliedMembershipFees}
                            </div>
                          ) : (
                            '-'
                          )}
                        </div>
                      )}
                    </>
                  )}
                  {coupon &&
                    !isCouponOnRenew &&
                    (!isNewLogic || coupon?.type !== COUPON_TYPE?.FLAT?.value) && (
                      <div className="d-flex justify-between">
                        <div className="lib-modal-text text-color-green">
                          Coupon Discount{' '}
                          {COUPON_TYPE.FLAT.value !== coupon?.type &&
                            `(${coupon?.value}%)`}{' '}
                          ({coupon?.name}){' '}
                        </div>
                        {coupon !== '-' ? (
                          <div className="lib-modal-text-value text-color-green">
                            - ₹ {parseFloat(couponDiscount?.toFixed(2))}
                          </div>
                        ) : (
                          '-'
                        )}
                      </div>
                    )}
                  {Discount && (
                    <div className="d-flex justify-between">
                      <div className="lib-modal-text">
                        Discount
                        {Discount}
                      </div>
                      <div className="lib-modal-text-value">
                        - ₹ {(totalAmount * Discount) / 100}
                      </div>
                    </div>
                  )}
                  {!(isTrialPeriod === true) &&
                    isTrialPeriod === false &&
                    isDamageWaiver &&
                    damageWaiverFeesApplied && (
                      <div className="d-flex justify-between">
                        <div className="lib-modal-text">Damage Waiver Charges</div>
                        <div className="lib-modal-text-value">
                          {damageWaiverFees > finalDamageWaiverFees && (
                            <span className="lib-modal-text-line-through mr-8">
                              ₹ {damageWaiverFees}
                            </span>
                          )}
                          + ₹ {finalDamageWaiverFees}
                        </div>
                      </div>
                    )}
                  {gstApplied && gstPercentage > 0 && (
                    <div className="d-flex justify-between">
                      <div className="lib-modal-text">GST Applied</div>
                      <div className="lib-modal-text-value">
                        + ₹ {gstDeduction?.toLocaleString('en-IN')}
                      </div>
                    </div>
                  )}
                  {coupon &&
                    !isCouponOnRenew &&
                    isNewLogic &&
                    coupon?.type === COUPON_TYPE?.FLAT?.value && (
                      <div className="d-flex justify-between">
                        <div className="lib-modal-text text-color-green">
                          Coupon Discount ({coupon?.name})
                        </div>
                        {coupon !== '-' ? (
                          <div className="lib-modal-text-value text-color-green">
                            - ₹ {parseFloat(couponDiscount?.toFixed(2))}
                          </div>
                        ) : (
                          '-'
                        )}
                      </div>
                    )}
                  <div className="d-flex justify-between">
                    <h4>Total</h4>
                    <h4>₹ {grandTotal}</h4>
                  </div>
                </>
              )}
            </>
          )}
      </ModalComponent>
    </>
  );
};

export default InvoiceModal;
